/**
 * Media URL Utility
 * Handles media file URLs for both development and production environments
 * 
 * Development: Uses local Django server (http://localhost:8000/media/...)
 * Production: Uses DigitalOcean Spaces CDN (https://carouselbucket.sgp1.digitaloceanspaces.com/media/...)
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
const MEDIA_URL = process.env.REACT_APP_MEDIA_URL || '';

/**
 * Get the full URL for a media file
 * @param {string} path - The media file path (e.g., '/media/carousel_images/1/image.jpg' or 'carousel_images/1/image.jpg')
 * @returns {string} - The full URL to access the media file
 */
export const getMediaUrl = (path) => {
  if (!path) return '';
  
  // If path is already a full URL (starts with http:// or https://), return as is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  
  // If MEDIA_URL is set (production with DigitalOcean Spaces)
  if (MEDIA_URL) {
    // Remove leading /media/ if present, as MEDIA_URL already includes it
    const cleanPath = path.replace(/^\/media\//, '');
    return `${MEDIA_URL}/${cleanPath}`;
  }
  
  // Development: Use local Django server
  // Remove /api from API_BASE_URL for media files
  const baseUrl = API_BASE_URL.replace('/api', '');
  
  // Ensure path starts with /media/
  const mediaPath = path.startsWith('/media/') ? path : `/media/${path}`;
  
  return `${baseUrl}${mediaPath}`;
};

/**
 * Check if we're using DigitalOcean Spaces (production)
 * @returns {boolean}
 */
export const isUsingSpaces = () => {
  return !!MEDIA_URL;
};

/**
 * Get the base media URL
 * @returns {string}
 */
export const getMediaBaseUrl = () => {
  if (MEDIA_URL) {
    return MEDIA_URL;
  }
  return `${API_BASE_URL.replace('/api', '')}/media`;
};

const mediaUrlUtils = {
  getMediaUrl,
  isUsingSpaces,
  getMediaBaseUrl
};

export default mediaUrlUtils;
